import { CheckCircle } from "lucide-react";

export default function StepIndicator({ number, label, active, completed }) {
  return (
    <div className="flex flex-col items-center">
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors ${
          completed
            ? "bg-green-500 text-white"
            : active
            ? "bg-primary text-white"
            : "bg-gray-200 text-gray-500"
        }`}
      >
        {completed ? <CheckCircle className="w-5 h-5" /> : number}
      </div>
      <span className={`text-xs mt-1 font-medium ${active ? "text-gray-900" : "text-gray-500"}`}>{label}</span>
    </div>
  );
}
